import { render, staticRenderFns } from "./searchIntentAP.vue?vue&type=template&id=5af17496&scoped=true&"
import script from "./searchIntentAP.vue?vue&type=script&lang=js&"
export * from "./searchIntentAP.vue?vue&type=script&lang=js&"
import style0 from "./searchIntentAP.vue?vue&type=style&index=0&id=5af17496&lang=less&scoped=true&"
import style1 from "./searchIntentAP.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af17496",
  null
  
)

component.options.__file = "searchIntentAP.vue"
export default component.exports